import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';

import { AuthFeatureService } from '@/core/auth/services/auth.service';

export const testLoginGuard: CanActivateFn = () => {
  const auth = inject(AuthFeatureService);
  const router = inject(Router);

  return auth.availability().pipe(
    map((availability) => (availability.enabled ? true : router.parseUrl('/login'))),
    catchError(() => of(router.parseUrl('/login'))),
  );
};
